import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import {
    ListIcon,
    NotificationsIcon,
    LiveTvIcon,
    BarChartIcon,
    LogoutIcon
} from '../icons';
import styles from './BottomNav.module.scss';

const BottomNav: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { logout, admin } = useAuth();
    const { t } = useTranslation();

    const currentPath = location.pathname.split('/')[1] || 'content';

    // Отслеживание ширины экрана для скрытия кнопки трансляции на десктопе
    const [isMobileWidth, setIsMobileWidth] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileWidth(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleNavClick = async (path: string) => {
        if (path === 'logout') {
            try {
                await logout();
                navigate('/login');
            } catch (error) {
                console.error('Ошибка при выходе:', error);
            }
        } else {
            navigate(`/${path}`);
        }
    };

    return (
        <nav className={styles.bottomNav}>
            <div className={styles.navContainer}>
                <button
                    className={`${styles.navButton} ${currentPath === 'content' ? styles.active : ''}`}
                    onClick={() => handleNavClick('content')}
                    aria-label={t('navigation.content')}
                >
                    <span className={styles.navIcon}>
                        <ListIcon />
                    </span>
                    <span className={styles.navLabel}>{t('navigation.content')}</span>
                </button>

                <button
                    className={`${styles.navButton} ${currentPath === 'notifications' ? styles.active : ''}`}
                    onClick={() => handleNavClick('notifications')}
                    aria-label={t('navigation.notifications')}
                >
                    <span className={styles.navIcon}>
                        <NotificationsIcon />
                    </span>
                    <span className={styles.navLabel}>{t('navigation.notifications')}</span>
                </button>

                {/* Кнопка трансляции доступна только на мобильных устройствах (ширина <= 767px) */}
                {admin?.language === "RU" && isMobileWidth && <button
                    className={`${styles.navButton} ${currentPath === 'livestream' ? styles.active : ''}`}
                    onClick={() => handleNavClick('livestream')}
                    aria-label={t('navigation.livestream')}
                >
                    <span className={styles.navIcon}>
                        <LiveTvIcon />
                    </span>
                    <span className={styles.navLabel}>{t('navigation.livestream')}</span>
                </button>}

                <button
                    className={`${styles.navButton} ${currentPath === 'statistics' ? styles.active : ''}`}
                    onClick={() => handleNavClick('statistics')}
                    aria-label={t('navigation.statistics')}
                >
                    <span className={styles.navIcon}>
                        <BarChartIcon />
                    </span>
                    <span className={styles.navLabel}>{t('navigation.statistics')}</span>
                </button>

                <button
                    className={`${styles.navButton} ${currentPath === 'logout' ? styles.active : ''}`}
                    onClick={() => handleNavClick('logout')}
                    aria-label={t('navigation.logout')}
                >
                    <span className={styles.navIcon}>
                        <LogoutIcon />
                    </span>
                    <span className={styles.navLabel}>{t('navigation.logout')}</span>
                </button>
            </div>
        </nav>
    );
};

export default BottomNav;